import React, { ComponentType, FunctionComponent } from 'react';
import ErrorBoundary from '.';

export function withErrorBoundary<Props = {}>(
  WrappedComponent: ComponentType<Props>,
  name: string
): FunctionComponent<Props> {
  const WrapperComponent: FunctionComponent<Props> = (props: Props) => {
    return (
      <ErrorBoundary name={name}>
        <WrappedComponent {...props} />
      </ErrorBoundary>
    );
  };
  WrapperComponent.displayName = `withErrorBoundary(${name})`;
  return WrapperComponent;
}
